module.exports = __webpack_public_path__ + "static/img/carousel_01.8ded1b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel_01.png
// module id = +e5v
// module chunks = 0